import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  bottomBar: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    background: '#f9f9f9',
    height: 80,
  },
  copyright: {
    marginLeft: theme.spacing(6),
    fontFamily: 'Roboto',
    color: '#000000',
    fontWeight: 500,
    fontSize: 14,
  },
}));

function Copyright() {
  const classes = useStyles();
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      className={classes.copyright}
    >
      {/* {' © '}
      {new Date().getFullYear()}
      {'-'}
      {new Date().getFullYear() + 1}
      <Link color="inherit" href="https://spacemonk.io/">
        {' SpaceMonk Technologies Pvt Ltd.'}
      </Link>{' '}
      {' All rights reserved.'} */}
    </Typography>
  );
}

const BottomBar = () => {
  const classes = useStyles();
  return (
    <Box className={classes.bottomBar}>
      <Copyright />
    </Box>
  );
};

export default BottomBar;
